import API from '../../services/api';
import { getCampaignOptions } from '../../analyticsWidgets/campaigns';

export const loadMobileCampaignOptions = async (companyId, availableSites) => {
  if (!companyId) return [];
  const campaigns = new Map();
  const visited = new Set();
  let page = '';
  do {
    visited.add(page);
    const response = await API.getCampaigns(companyId, page);
    (response.campaigns || []).forEach(campaign => campaigns.set(campaign.id, campaign));
    page = response.nextPageToken || '';
  } while (page && !visited.has(page));
  return getCampaignOptions([...campaigns.values()], availableSites);
};
